import { RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";

// TODO: tokuizipCd等の項目をDBに合わせた変数名にしたい(受注入力も)

export type B010060Request = {
  juchuworkdenpyoNo: string;
  juchuYmd: string;
  denpyoYmd: string;
  shukayoteiYmd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  eigyoCd: string;
  shainCd: string;
  chohaKbn: string;
  hasokbnCd: string;
  hasosakiCd: string;
  juchuHaneiKbn: string;
  ppgakeKbn: string;
  netsukeKbn: string;
} & Partial<{
  seisakuYmd: string;
  jisanYmd: string;
  nohinyoteiYmd: string;
  tokuizipCd: string;
  tokuiaddress1: string;
  tokuiaddress2: string;
  tokuitelNo: string;
  tokuifaxNo: string;
  nonyuzipCd: string;
  nonyuaddress1: string;
  nonyuaddress2: string;
  nonyutelNo: string;
  nonyufaxNo: string;
  chumonNo: string;
  bumonCd: string;
  assistantCd: string;
  bikoCd: string;
  biko: string;
  unsogaishaCd: string;
  denpyoshubetsuCd: string;
  tenpudenpyoCd: string;
  denpyoKbn: string;
  ritsu: string;
  bunrui: string;
  hinbetsuNo: string;
  nohinsaki: string;
  uribaNm: string;
  naisen: string;
  tantosha: string;
  lineCd: string;
  ediKbn: string;
  ediJuchuNo: string;
  ediMemo: string;
  version: string;
  b010060MeiRequest: B010060MeiRequest[];
}>;

export type B010060MeiRequest = {
  juchugyoNo: string;
  uchiwakeKbn: string;
  shohinCd: string;
  sokoCd: string;
  janCd: string;
  juchusu: string;
  juchutanka: string;
  kakeritsu: string;
} & Partial<{
  shohinNm: string;
  edishohinNm: string;
  aiteCd: string;
  tenyuryokujuchuKbn: string;
  juchuKin: string;
  kazeiKbn: string;
  meisaibikoCd: string;
  meisaibiko: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  tenyuryokujodaiKbn: string;
  jodaitanka: string;
  setshohinKbn: string;
  shohinshubetsuKbn: string;
  crtDate: string;
  crtshainCd: string;
  b010060MeiKoseiRequest: B010060MeiKoseiRequest[];
}>;

export type B010060MeiKoseiRequest = {
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  janCd: string;
  sokoCd: string;
  koseisu: string;
  juchutanka: string;
  juchuKin: string;
  kakeritsu: string;
} & Partial<{
  aiteCd: string;
  shohinNm: string;
  hitsuyosu: string;
  tenyuryokujuchuKbn: string;
  kazeiKbn: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  tenyuryokujodaiKbn: string;
  jodaitanka: string;
  shohinshubetsuKbn: string;
  crtDate: string;
  crtshainCd: string;
}>;

//受注ワーク入力更新処理メソッド
export const B010060Update = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // マッピング
  // 明細
  const meiData: B010060MeiRequest[] = rows.map((row: any) => {
    // セット構成品の名称を変更
    row.b010060MeiKoseiRequest = [...row.koseiData];
    return row;
  });

  // ヘッダー
  const data: B010060Request = {
    juchuworkdenpyoNo: fields.juchuworkdenpyoNo,
    juchuYmd: fields.juchuYmd,
    seisakuYmd: fields.seisakuYmd,
    jisanYmd: fields.jisanYmd,
    denpyoYmd: fields.denpyoYmd,
    nohinyoteiYmd: fields.nohinyoteiYmd,
    shukayoteiYmd: fields.shukayoteiYmd,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    tokuiNm: fields.tokuiNm,
    tokuizipCd: fields.tokuiPostCd,
    // tokuizipCd: fields.tokuizipCd,
    tokuiaddress1: fields.tokuiAddress1,
    // tokuiaddress1: fields.tokuiaddress1,
    tokuiaddress2: fields.tokuiAddress2,
    // tokuiaddress2: fields.tokuiaddress2,
    tokuitelNo: fields.tokuiTelNo,
    // tokuitelNo: fields.tokuitelNo,
    tokuifaxNo: fields.tokuiFaxNo,
    // tokuifaxNo: fields.tokuifaxNo,
    nonyuCd: fields.nonyuCd,
    nonyushitenCd: fields.nonyushitenCd,
    nonyuNm: fields.nonyuNm,
    nonyuzipCd: fields.nonyuPostCd,
    // nonyuzipCd: fields.nonyuzipCd,
    nonyuaddress1: fields.nonyuAddress1,
    // nonyuaddress1: fields.nonyuaddress1,
    nonyuaddress2: fields.nonyuAddress2,
    // nonyuaddress2: fields.nonyuaddress2,
    nonyutelNo: fields.nonyuTelNo,
    // nonyutelNo: fields.nonyutelNo,
    nonyufaxNo: fields.nonyuFaxNo,
    // nonyufaxNo: fields.nonyufaxNo,
    chumonNo: fields.chumonNo,
    eigyoCd: fields.eigyoCd,
    bumonCd: fields.bumonCd,
    shainCd: fields.shainCd,
    assistantCd: fields.assistantCd,
    chohaKbn: fields.chohaKbn.value,
    hasokbnCd: fields.hasokbnCd.value,
    hasosakiCd: fields.hasosakiCd.value,
    unsogaishaCd: fields.unsogaishaCd,
    ppgakeKbn: fields.ppgakeKbn.value,
    netsukeKbn: fields.netsukeKbn.value,
    denpyoshubetsuCd: fields.denpyoshubetsuCd,
    tenpudenpyoCd: fields.tenpudenpyoCd,
    denpyoKbn: fields.denpyoKbn,
    ritsu: fields.ritsu,
    bunrui: fields.bunrui,
    hinbetsuNo: fields.hinbetsuNo,
    uribaNm: fields.uribaNm,
    naisen: fields.naisen,
    tantosha: fields.tantosha,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    nohinsaki: fields.nohinsaki,
    lineCd: fields.lineCd,
    ediKbn: fields.ediKbn,
    ediJuchuNo: fields.ediJuchuNo,
    ediMemo: fields.ediMemo,
    juchuHaneiKbn: fields.juchuHaneiKbn,
    version: fields.version,
    b010060MeiRequest: [...meiData],
  };

  return RestClient.put("b010060/update", data);
};
